import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const TextSecure = styled.span`
  ${({ theme }) => css(theme.typographys.tiny.regular)}
  color: ${({ theme }) => theme.colors.grey[4]};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      margin-top: 24px;
    }
  `}
  span:first-of-type {
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      margin-right: 10px;
    }

    b {
      padding-left: 4px;
    }
  }

  [dir="rtl"] & span:first-of-type {
    svg {
      margin-right: 0;
      margin-left: 10px;
    }

    b {
      padding-left: 0;
      padding-right: 4px;
    }
  }

`

export const TextBold = styled.b`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.grey[4]};
`
